<template>
  <div>
    <b-row>
      <b-col cols="3">
        <b-form inline>
          &nbsp;<input v-if="expedition !== 'aguardando_retirada' && expedition !== 'entregue'
            " type="checkbox" v-model="allSelected" :disabled="filters.status == 'delivered'" />&nbsp;&nbsp;&nbsp;
          <font :size="fontSize">
            <span class="fas fa-sync-alt btn-edit" aria-hidden="true" title="Atualizar" @click="refreshTable()"
              style="cursor: pointer">
            </span>
          </font>
          &nbsp;&nbsp;&nbsp;
          <font :size="fontSize" v-if="expedition !== 'aguardando_retirada' && expedition !== 'entregue'
            ">
            <span>
              <action-menu-dropdown style="cursor: pointer" :items="items" :usr_orders="usr_orders" :filters="filters"
                :expedition="expedition" :checked="checkedOrders" :iTabs="iTabs"
                :expeditionsTabs="expeditionsTabs"></action-menu-dropdown>
            </span>
          </font>
        </b-form>
      </b-col>
    </b-row>
    <b-table v-scroll="handleScroll" class="box" show-empty empty-text="Sem registros para listar"
      empty-filtered-text="Nenhum registro encontrado" responsive striped small :items="items" :fields="fields"
      :current-page="currentPage" :per-page="perPage" :filter="filtro" @filtered="onFiltered" :busy="isBusy">
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner variant="success"></b-spinner>
          <strong variant="success">Loading...</strong>
        </div>
      </template>

      <template #head(id)="scope"> </template>

      <template #head(created_by)="scope">
        <div class="text-nowrap text-left">{{ $t('Canal') }}</div>
      </template>

      <template #head(sku)="scope">
        <div class="text-nowrap text-left">{{ $t('SKUs') }}</div>
      </template>

      <template #head(external)="scope">
        <div class="text-nowrap text-left">{{ $t('IDs do pedido') }}</div>
      </template>

      <template #head(created)="scope">
        <div class="text-nowrap text-center">{{ $t('Data de criação') }}</div>
      </template>

      <template #head(payer_name)="scope">
        <div class="text-nowrap text-left">{{ $t('Nome completo') }}</div>
      </template>

      <template #head(total)="scope">
        <div class="text-nowrap">{{ $t('Total') }}</div>
      </template>

      <template #head(sla)="scope">
        <div class="text-nowrap">
          {{ expedition == "entregue" ? $t("Data da entrega") : "SLA" }}
        </div>
      </template>

      <template #head(observacao)="scope">
        <span v-show="expedition === 'erro_ao_gerar_nota_fiscal'"> {{ $t('Observação') }}</span>
      </template>

      <template #head(action)="scope">
        <div v-show="expedition !== 'a_combinar' &&
          expedition !== 'aguardando_retirada' &&
          expedition !== 'em_transito' &&
          expedition !== 'entregue' &&
          expedition !== 'erro_ao_gerar_nota_fiscal'
          ">
          Ações
        </div>
      </template>

      <template v-slot:cell(id)="data">
        <input v-if="expedition !== 'aguardando_retirada' && expedition !== 'entregue'
          " type="checkbox" :id="data.item.id" :value="data.item.id" :checked="allSelected" v-model="checkedOrders"
          :disabled="data.item.status == 'delivered'" />
      </template>

      <template v-slot:cell(created_by)="data">
        <font :size="fontSize">
          <img
            :src="'https://painel.plugg.to/assets/images/channels/' +
              (data.item.channel === '99 Compras'
                ? '5894b180e2a8c61c12f3a565407f53f2'
                : data.item.created_by_id) +
              '.svg'"
            style="vertical-align: middle; width: 75px; min-width: 70px"
          /><br />
          <b-badge variant="info" style="cursor: default" class="mt-1">
            <span v-if="data.item.channel_account">
              {{ data.item.channel_account }}
            </span>
          </b-badge>
        </font>
      </template>

      <template v-slot:cell(sku)="data">
        <font v-if="data.item.items.length" :size="fontSize">
          <span style="color: green" @click="data.item.show_all = !data.item.show_all">
            <i v-if="!data.item.show_all" class="fa fa-plus"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </font>
        <font :size="fontSize" v-for="items in data.item.items" v-bind:key="items.id">
          <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :badge="false"
            :texto1="'SKU: ' + ofNull(items.sku) + ' '" :texto2="' <small>(' + ofNull(items.original_sku) + ')</small> '"
            :texto3="' Nome: ' + ofNull(items.name) + ' '" :show_all="data.item.show_all" /><br />
        </font>
        <font :size="fontSize">
          {{ `Quantidade: ${calculateTotalQuantity(data.item.items)}` }}
        </font>
      </template>

      <template v-slot:cell(external)="data">
        <div class="text-left">
          <font :size="fontSize">
            <span v-for="i in transformExternal(data.item.external)" :key="i.app">
              <b-badge variant="secondary" style="cursor: default" v-b-tooltip.hover :title="i.app" class="mt-1">
                {{ parseID(i.external) }}
              </b-badge>
              <br />
            </span>
          </font>
        </div>
      </template>

      <template v-slot:cell(created)="data">
        <div class="text-center">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :badge="false"
              :texto="data.item.created + 'h'" />
          </font>
        </div>
      </template>

      <template v-slot:cell(payer_name)="data">
        <div class="text-left">
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :badge="false"
              :texto="data.item.payer_name" />
          </font>
        </div>
      </template>

      <template v-slot:cell(total)="data">
        <div>
          <font :size="fontSize">
            <Sla :estimate_delivery_date="data.item.estimate_delivery_date" :badge="false" :texto="data.item.total" />
          </font>
        </div>
      </template>

      <template v-slot:cell(sla)="data">
        <font v-if="expedition == 'entregue'" :size="fontSize">
          {{ data.item.modified }}
        </font>
        <font v-else :size="fontSize">
          <Sla v-if="data.item.before_status !== 'delivered' &&
            data.item.before_status !== 'canceled'
            " :estimate_delivery_date="data.item.estimate_delivery_date" :before_status="data.item.before_status"
            :badge="true" :texto="data.item.expected_send_date" />
        </font>
      </template>

      <template v-slot:cell(observacao)="data">
        <span v-if="data.item.observacao[0] && expedition === 'erro_ao_gerar_nota_fiscal'">
          <font :size="fontSize">
            <ReduceText :objStringg="data.item.observacao[0].message" :descBool="true" />
          </font>
        </span>
      </template>

      <template v-slot:cell(action)="data">
        <i v-if="expedition === 'pendente_de_separacao' || expedition === 'pronto_para_embalar'" style="cursor: pointer" class="btn-edit fas fa-clipboard-list"
          title="Lista de Picking" @click="listaDeSeparacao([...data.item])">
        </i>
        &nbsp;
        <ConfirmarSeparacao v-if="expedition === 'em_separacao'" :pedido_id="data.item.id" />
        &nbsp;
        <i v-if="expedition === 'pronto_para_embalar'" style="cursor: pointer" @click="sidebarPickingShowF(
          data.item.items,
          data.item.id,
          data.item.created_by,
          data.index,
          data.item
        )
          " class="btn-edit fa fa-check" :title="$t('Conferência')">
        </i>
        &nbsp;
        <SeparadosButtonSolicitarNFe v-if="expedition === 'separado'" :pedido_id="data.item.id" />
        <PularNfe v-if="expedition === 'aguardando_nota_fiscal'" :pedido_id="data.item.id" />
      </template>
    </b-table>
    <b-row>
      <b-col class="text-center">
        <span v-if="endItems"> Fim, não tem mais pedidos para listar.</span>
        <div v-if="loadSmallg" class="text-center text-success my-2">
          <b-spinner variant="success"></b-spinner><br />
          <strong variant="success">Carregando mais pedidos...</strong>
        </div>
      </b-col>
    </b-row>
    <br />
    <div v-if="showAll === 'pronto_para_embalar'">
      <SidebarPicking :expedition="showAll" :apps="apps" />
    </div>
  </div>
</template>

<script>
import SeparadosButtonSolicitarNFe from "./Nfe/SeparadosButtonSolicitarNFe.vue";
import ActionMenuDropdown from "./ActionMenu/ActionMenuDropdown.vue";
import ConfirmarSeparacao from "./Support/ConfirmarSeparacao.vue";
import SidebarPicking from "./Sidebar/SidebarPicking.vue";
import { AppService } from "../../../services/appService";
import ReduceText from "./Support/ReduceText.vue";
import Etiqueta from "./ActionTable/Etiqueta.vue";
import barramento from "../../../barramento";
import PularNfe from "./Nfe/PularNfe.vue";
import Nfe from "./ActionTable/Nfe.vue";
import Sla from "./Support/Sla.vue";
import moment from "moment";
import axios from "axios";

export default {
  name: "Tables",
  props: [
    "filters",
    "url",
    "url_next",
    "expedition",
    "checkFaturador",
    "usr_orders",
    "showAll",
    "apps",
    "iTabs",
    "expeditionsTabs",
  ],
  components: {
    ActionMenuDropdown,
    Sla,
    Etiqueta,
    PularNfe,
    Nfe,
    ReduceText,
    SidebarPicking,
    SeparadosButtonSolicitarNFe,
    ConfirmarSeparacao,
  },
  data() {
    return {
      isBusy: false,
      fontSize: 2,
      fields: [
        { key: "id", label: "" },
        { key: "created_by", label: "Canal" },
        { key: "sku", label: "SKUs" },
        { key: "external", label: "IDs do pedido" },
        { key: "created", label: "Data de criação" },
        { key: "payer_name", label: "Nome completo" },
        { key: "total", label: "Total" },
        { key: "sla", label: "SLA" },
        { key: "observacao", label: "Observação" },
        { key: "action", label: "Ações" },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 50,
      filtro: null,
      filtroIn: null,
      allSelected: false,
      checkedOrders: [],
      loadSmallg: false,
      scrollD: 2100,
      endItems: false,
      previousCount: 0,
      beforeMountCount: 0,
      ordersRequestId: 0,
      sidebarPickingNextTimeout: null,
    };
  },
  watch: {
    checkedOrders: {
      handler(newValue, oldValue) {
        //barramento.$emit("orders_table_checked", this.checkedOrders);
      },
      deep: true,
    },
    allSelected: {
      handler(newValue, oldValue) {
        this.checkedOrders = [];
        if (newValue) {
          for (var i = 0; i < this.items.length; i++) {
            this.checkedOrders[i] = this.items[i].id;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    listaDeSeparacao(items) {
      barramento.$emit("expedition_lista_de_sepacao", items);
    },
    sidebarPickingShowF(items, id, created_by, index, obj) {
      this.items[index]._rowVariant = "warning";
      barramento.$emit(`siderbar_picking_expedition_${this.showAll}`, {
        items: items,
        index: index,
        created_by: created_by,
        id: id,
        obj: obj
      });

    },
    transformExternal(object) {
      let arr = [];
      if (object && typeof object === "object") {
        for (let key in object) {
          arr.push({
            app: AppService.getNameOfAppByClientID(key), // key is client_id
            external: object[key],
          });
        }
      }
      return arr;
    },
    parseID(external) {
      if (external && typeof external === "string") {
        let match = external.match(",");
        if (match && match.index) {
          return external.slice(0, match.index) + "...";
        }
      }

      return external;
    },
    calculateTotalQuantity(items) {
      return items.reduce((total, item) => total + item.quantity, 0);
    },
    toggleBusy: function () {
      this.isBusy = !this.isBusy;
    },
    parseDate(dateString) {
      if (typeof dateString === "string") {
        dateString = dateString.replace("T", " ");
        dateString = dateString.replace(".000Z", "");
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const horas = date.getHours().toString().padStart(2, "0");
        const minutos = date.getMinutes().toString().padStart(2, "0");
        return `${day}/${month}/${year} às ${horas}:${minutos}h`;
      }
      return dateString;
    },
    formatDate(value, loc = null) {
      if (value) {
        if (loc !== "US") {
          let date = moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
          if (date === "Invalid date") {
            return value;
          }
          return date;
        } else {
          return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },
    formatCurrency(value) {
      return Intl.NumberFormat("pt-br", {
        currency: "BRL",
        style: "currency",
      }).format(value);
    },
    formatStatusText(status) {
      if (status === undefined || status == null) {
        return "";
      }
      switch (status) {
        case "approved":
          return "Aprovado";
        case "picking":
          return "Em separação";
        case "delivered":
          return "Entregue";
        case "in_transit":
          return "Em transito";
        case "invoiced":
          return "Faturado";
        case "shipped":
          return "Enviado";
        case "canceled":
          return "Cancelado";
        case "invoice_error":
          return "Erro ao gerar nota fiscal";
        case "shipping_error":
          return "Erro ao enviar entrega";
        case "pending":
          return "Pendente";
        case "partial_payment":
          return "Pagamento parcial";
        case "shipping_informed":
          return "Envio informado";
        default:
          return status;
      }
    },
    getAppNameByClientID(clientID) {
      if (clientID) {
        return AppService.getNameOfAppByClientID(clientID);
      }
    },
    refreshTable() {
      this.setFilter(this.filtroIn);
    },
    setFilter(filters) {
      this.ordersRequestId++;
      clearTimeout(this.sidebarPickingNextTimeout);
      barramento.$emit(`siderbar_picking_expedition_hide_${this.expedition}`);
      this.checkedOrders = [];
      this.allSelected = false;
      this.items = [];
      this.loadSmallg = false;
      this.endItems = false;
      this.scrollD = 2100;
      var f = filters;
      if (!f) f = this.filters;
      this.getOrders(this.url, true, false, f, false, this.expedition);
    },
    ofNull(n = null) {
      if (n) return n;
      return "";
    },
    getEstimateDeliveryDate(shipments) {
      if (shipments.length) {
        return this.formatDate(shipments[0].estimate_delivery_date);
      }
      return null;
    },
    onFiltered: function (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleScroll: function (evt, el) {
      var scrollY = window.pageYOffset;

      if (this.loadSmallg === false && this.endItems == false && scrollY > this.scrollD) {
        this.nextGetOrders();
        this.scrollD = scrollY + 200;
      }
    },
    nextGetOrders: function () {
      let lastItem;

      if (this.items && this.items.length > 0)
        lastItem = this.items[this.items.length - 1];

      if (typeof lastItem == "undefined") return;

      this.loadSmallg = true;
      this.perPage = this.perPage + 50;

      let object1 = this.filtroIn;
      let newObj = this.filters;

      if (object1 !== null) {
        Object.keys(object1).forEach((prop) => {
          if (object1[prop]) newObj[prop] = object1[prop];
        });
      }

      this.getOrders(this.url_next + lastItem.id, false, true, newObj, false);
    },
    getOrders: function (
      url,
      loagindTable = false,
      loadSmallg = false,
      f = null,
      beforeMountCount = false,
      expedition_tab = null
    ) {
      const requestId = this.ordersRequestId;

      if (loagindTable) this.isBusy = true;

      var filterPort = this.filters;
      if (f) filterPort = f;
      if (!f) this.previousCount = 0;

      axios.post(url, filterPort).then((response) => {
        if (requestId !== this.ordersRequestId) return;

        var orders = [];
        orders = !!response.data.orders ? response.data.orders : response.data;

        if (orders.length < 50) this.endItems = true;
        else this.endItems = false;
        var first_order = true;
        for (var i = 0; i < orders.length; i++) {
          var r = null;
          r = this.items.find((fruit) => fruit.id === orders[i].id);
          if (!r) {
            this.items.push({
              id: orders[i].id,
              order_id: orders[i].order_id,
              created_by_id: orders[i].created_by,
              created_by: this.getAppNameByClientID(orders[i].created_by),
              receiver_name: `${orders[i].receiver_name} ${orders[i].receiver_lastname}`,
              original_id: orders[i].original_id,
              nfes: orders[i].shipments instanceof Array ? orders[i].shipments.map((oneShipment) => oneShipment.nfe_number). join(', ') : '',
              channel: orders[i].channel,
              channel_account: orders[i].channel_account,
              created: this.formatDate(orders[i].created),
              external: orders[i].external,
              user_id: orders[i].user_id,
              payer_name:
                this.ofNull(orders[i].payer_name) +
                " " +
                this.ofNull(orders[i].payer_lastname),
              metodo_etiqueta: null,
              metodo_envio: null,
              impressao: null,
              observacao: orders[i].log_history,
              items: orders[i].items,
              total: this.formatCurrency(orders[i].total),
              status: this.formatStatusText(orders[i].status),
              before_status: orders[i].status,
              modified: this.parseDate(orders[i].modified),
              expected_send_date: this.parseDate(orders[i].expected_send_date),
              before_expected_send_date: orders[i].expected_send_date,
              estimate_delivery_date: this.getEstimateDeliveryDate(
                orders[i].shipments
              ),
              tags: orders[i].tags,
              shipments: orders[i].shipments,
              before: orders[i],
              invoicing_accepted: orders[i].invoicing_accepted,
              shipping_accepted: orders[i].shipping_accepted,
              delivery_accepted: orders[i].delivery_accepted,
              show_all: false,
              _rowVariant: "",
            });
            if(first_order && expedition_tab == 'pronto_para_embalar' && typeof filterPort.sku !== 'undefined'){
                first_order = false
                var itemIndex = this.items.length - 1;
                this.sidebarPickingShowF(
                  this.items[itemIndex].items,
                  this.items[itemIndex].id,
                  this.items[itemIndex].created_by_id,
                  itemIndex,
                  this.items[itemIndex]
                )

            }
          }
        }
        this.totalRows = this.items.length;
        if (loagindTable) this.isBusy = false;
        if (loadSmallg) this.loadSmallg = false;
        if (beforeMountCount) this.beforeMountCount = response.data.total;
        if (!!response.data.total) this.previousCount = response.data.total;
        if (
          !response.data.total &&
          !!response.data.length &&
          this.previousCount < this.beforeMountCount
        )
          this.previousCount = this.previousCount + response.data.length;
        if (this.expedition == "pendente_de_separacao") {
          barramento.$emit("action_props_totos", {
            items: this.items,
            value: null,
            applyFilter: null,
            loadTotalOrders: null,
            filters: this.filters,
          });
        }

        barramento.$emit("count_" + this.expedition, {
          valor: this.previousCount,
          expedition: this.expedition,
        });
      });
    },
  },
  beforeMount() {
    this.getOrders(this.url, true, false, null, true, this.expedition);
  },
  beforeDestroy() {
    clearTimeout(this.sidebarPickingNextTimeout);
    barramento.$off(this.expedition);
    barramento.$off(`expedition_splice_${this.expedition}`);
    barramento.$off(`expedition_loding_${this.expedition}`);
    barramento.$off(`expedition_sidebar_picking_next_${this.showAll}`);
    barramento.$off(`expedition_sidebar_picking_clear_${this.showAll}`);
  },
  created() {
    barramento.$on(this.expedition, (filters) => {
      this.filtroIn = filters;
      this.setFilter(filters);
    });
    barramento.$on(`expedition_loding_${this.expedition}`, (filter) => {
      barramento.$emit(`expedition_click_show_hide_${this.expedition}`);
      this.setFilter(filter || this.filters);
    });
    barramento.$on(`expedition_splice_${this.expedition}`, (obj) => {
      switch (obj.status) {
        case "warning":
          for (var i in obj.ids) {
            this.items[
              this.items.findIndex((item) => item.id === obj.ids[i])
            ]._rowVariant = "warning";
          }
          break;

        case "success":
          for (var i in obj.ids) {
            this.items[
              this.items.findIndex((item) => item.id === obj.ids[i])
            ]._rowVariant = "success";
          }
          break;

        case "splice":
          for (var i in obj.ids) {
            this.items.splice(
              this.items.findIndex((item) => item.id === obj.ids[i]),
              1
            );
          }
          barramento.$emit(`count_decremente_${this.expedition}`, {
            valor: obj.ids.length,
            expedition: this.expedition,
            index: obj.index,
          });
          break;
      }
    });
    barramento.$on(
      `expedition_sidebar_picking_clear_${this.expedition}`,
      (index) => {
        this.items[index]._rowVariant = "";
      }
    );
    barramento.$on(
      `expedition_sidebar_picking_next_${this.expedition}`,
      (index) => {
        if (!this.items[index]) return;

        this.items[index]._rowVariant = "success";
        var orderId = this.items[index].id;
        var requestId = this.ordersRequestId;

        barramento.$emit(
          `siderbar_picking_expedition_hide_${this.expedition}`,
          null
        );

        clearTimeout(this.sidebarPickingNextTimeout);
        this.sidebarPickingNextTimeout = setTimeout(() => {
          if (requestId !== this.ordersRequestId) return;

          var currentIndex = this.items.findIndex((item) => item.id === orderId);
          if (currentIndex < 0) return;

          this.items.splice(currentIndex, 1);
          barramento.$emit(`count_decremente_${this.expedition}`, {
            valor: 1,
            expedition: this.expedition,
          });

          if (this.items[currentIndex]) {
            this.sidebarPickingShowF(
              this.items[currentIndex].items,
              this.items[currentIndex].id,
              this.items[currentIndex].created_by_id,
              currentIndex,
              this.items[currentIndex]
            );
          }
        }, 1800);
      }
    );
  },
};
</script>
<style>
.box {
  transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Tables.vue